import axios from "axios";
import { BASE_URL } from "./settings";

const URLS = {
  AJUDA: BASE_URL + "AjudaSubmodulo",
};

export default class AjudaService {

  static getAjuda = async (subModuloId) => {
    
    let url = URLS.AJUDA + "/?submoduloId=" + subModuloId;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (err) {
      return err;
    } finally {
      // this.setState({ loading: false });
    }
  };
}
